var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolcimPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 40,
    viewBox: "0 0 198 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 198,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198 0H0V40H198V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.001 5.81016V0H186.001V5.81016H180.001V11.6204H186.001V17.4305H192.001V11.6204H198V5.81016H192.001ZM164.201 22.3778L156.835 11.6012H148.362V39.4439H156.222V23.2406L164.023 34.0556H164.182L172.043 23.1639V39.4439H180.022V11.6012H171.547L164.201 22.3778ZM18.612 22.0134H8.019V11.6012H0V39.4439H8.019V28.859H18.612V39.4439H26.631V11.6012H18.612V22.0134ZM49.0446 11.0451C40.1148 11.0451 33.561 17.5264 33.561 25.5225V25.5992C33.561 33.5954 40.0158 40 48.9456 40C57.8754 40 64.4292 33.5187 64.4292 25.5225V25.4459C64.4292 17.4497 57.9744 11.0451 49.0446 11.0451ZM56.2518 25.5992C56.2518 29.6069 53.46 33.0393 49.0446 33.0393C44.6292 33.0393 41.7978 29.5302 41.7978 25.5225V25.4459C41.7978 21.4381 44.5896 18.0058 48.9654 18.0058C53.3412 18.0058 56.2518 21.4956 56.2518 25.5225V25.5992ZM79.7742 11.6012H71.7552V39.4439H93.0407V32.6749H79.7742V11.6012ZM132.006 39.4439H140.065V11.6012H132.006V39.4439ZM112.226 32.9626C108.167 32.9626 105.317 29.7028 105.317 25.5225V25.4459C105.317 21.3806 108.167 18.0825 112.226 18.0825C116.286 18.0825 116.899 19.348 118.543 21.3423L124.582 16.8552C122.028 13.442 118.226 11.0451 112.306 11.0451C103.535 11.0451 97.0596 17.4113 97.0596 25.5225V25.5992C97.0596 25.7526 97.0596 25.9252 97.0596 26.0786C97.218 33.9022 103.89 40.1342 111.989 39.9808C118.404 39.9808 122.067 37.3155 124.799 33.6913L118.76 29.5493C117.018 31.582 115.255 32.9243 112.226 32.9243V32.9626Z",
    fill: "url(#paint0_radial_76_2)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_76_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.404 -20.6328) scale(87.1992 84.4487)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#B2FE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#01FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041739"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolcimPlus);
export default __webpack_public_path__ + "static/media/holcim-plus.352323207e2532de136ef7b42c97202a.svg";
export { ForwardRef as ReactComponent };